export const MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL = 0;
export const MAX_NUMBER_OF_SCHOOL_VARIANCE_ALLOWED = 10000;
export const PEACHJAR_CONTACT_NUMBER = '(858) 997-2117';
export const DISTRICT_NCES_ID_LENGTH = 7;
export const SCHOOL_NCES_ID_LENGTH = 12;
export const PRIVATE_SCHOOL_NCES_ID_LENGTH = 8;
export const TERMS_AND_CONDITIONS_URL =
  'https://peachjar.com/privacy-policy-terms.html#terms';
export const PRIVACY_POLICY_URL =
  'https://peachjar.com/privacy-policy-terms.html#privacy';

/**
 * networkStatus 1

 * The query has never been run before and the query is now currently running. A query will still
 * have this network status even if a partial data result was returned from the cache, but a
 * query was dispatched anyway.
 */
export const APOLLO_QUERY_INITIAL_LOAD = 1;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/constants.js